import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventPage({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/EventPage"));
  console.log("Loading", AsyncEventPage.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventPage;
